import React from 'react';
import PropTypes from 'prop-types';

/**
 * ErrorBoundary específico para NotificationCenter
 * Garante que qualquer erro no sistema de notificações não quebre o app
 */
class NotificationErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.warn('[NotificationCenter] Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Renderizar nada - falha silenciosa
      return null;
    }

    return this.props.children;
  }
}

NotificationErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NotificationErrorBoundary;
